<template>
  <div class="container-fluid pm-page">
    <div class="pm-page-header pb-3">
      <h5 class="mb-0 font-weight-bold">Test Report</h5>
      <p class="text-secondary text-sm mb-0">QA Management</p>
    </div>

    <div class="row pb-2 pm-page-main">
      <div class="col-12 pm-page-col">
        <div class="card pm-page-card">
          <div v-if="visibleTeamTabs.length" class="card-header pb-0">
            <div class="tab-shell" role="tablist" aria-label="Test Report teams">
              <button
                v-for="tab in visibleTeamTabs"
                :key="tab.key"
                type="button"
                class="tab-item"
                :class="{ active: activeTeam === tab.key }"
                role="tab"
                :aria-selected="activeTeam === tab.key"
                @click="activeTeam = tab.key"
              >
                {{ tab.label }}
              </button>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2 pm-page-tab-body">
            <test-report-tab
              standalone
              :team-filter="activeTeam"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TestReportTab from "./components/tabs/TestReportTab.vue";
import {
  defaultPlanTeamTabKey,
  visiblePlanTeamTabs,
} from "@/utils/userTeams";
import "@/assets/css/pm-tab-scroll.css";
import "@/assets/css/plan-tab-scroll.css";

export default {
  name: "qa-test-report-board",
  components: { TestReportTab },
  data() {
    return {
      activeTeam: "team a",
    };
  },
  computed: {
    ...mapState(["user"]),
    userTeamSource() {
      return this.user?.teams?.length ? this.user.teams : this.user?.team;
    },
    visibleTeamTabs() {
      return visiblePlanTeamTabs(this.userTeamSource);
    },
  },
  watch: {
    user: {
      handler() {
        this.initActiveTeamFromUser();
      },
      deep: true,
    },
  },
  created() {
    this.initActiveTeamFromUser();
  },
  methods: {
    initActiveTeamFromUser() {
      const allowed = this.visibleTeamTabs.map((t) => t.key);
      if (!allowed.includes(this.activeTeam)) {
        this.activeTeam = defaultPlanTeamTabKey(this.userTeamSource);
      }
    },
  },
};
</script>

<style scoped>
.pm-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.pm-page-main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pm-page-col {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.pm-page-card {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pm-page-tab-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.card-header.pb-0 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.tab-shell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.3rem;
  border-radius: 12px;
  background: transparent;
}

.tab-item {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #696969;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding: 0.55rem 0.9rem;
  border: none;
  border-radius: 12px;
  background: #f5f5f5;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tab-item.active {
  color: #ffffff;
  background: #344767;
  box-shadow: 0 6px 14px rgba(52, 71, 103, 0.28);
}
</style>
